module.exports = __webpack_public_path__ + "img/logo.21337dcf.png";